module.exports = __webpack_public_path__ + "static/media/XIh.35ac5252.png";